module.exports = __webpack_public_path__ + "img/logo_console.e73b5f29.svg";